<template>
  <div class='oversea' v-loading.fullscreen="disabled">
    <!-- <div>这个框是测试用的，正式会去掉<el-input class="login_ipt first_login_ipt" v-model="email"  placeholder="输入ID"></el-input></div> -->
    <div class="detailbg">
      <img src="/static/images/activty/becomeseller/detailbg.png"><span @click="ShippingFee"></span>
    </div>
    <!-- <div>这个框是测试用的，正式会去掉<el-input class="login_ipt first_login_ipt" v-model="email"  placeholder="输入ID"></el-input></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_01.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_02.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_03.jpg"></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_04.jpg"><span @click="ShippingFee"></span></div>
    <div><img src="/static/images/activty/becomeseller/becomeseller_05.jpg"></div> -->
  </div>
</template>
<script>
import bus from '@/api/bus';

import {getInfo,setInfo} from "@/api/public";
export default {
  name: '',
  components: {},
  data() {
    return {
      email:'',
      disabled: false,
      userInfo:''
    }
  },
  watch: {},
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.becomeASeller'));
    this.userInfo = getInfo();
    
    this.getMemberInfo()
    this.getUserDetail()
  },
  methods: {
    // 获取用户详情
    getUserDetail() {
      let that = this;
      let data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
      that.$get(this.$interface.GetUserDetail, data).then(res => {
        if (res.result != 0) {
          let data = res.data;
          that.userDetail = data;
          console.log('getUserDetail', data)
          setInfo('PointCount', data.PointCount)
          setInfo('SumMoney', data.SumMoney)
          setInfo('HeadPortrait', data.HeadPortrait)
          setInfo('MemberSource', data.MemberSource)
          setInfo('WyAccId', data.WyAccId)
          setInfo('WyToken', data.WyToken)
          that.userInfo = getInfo();
        }
      })
    },
    // 获取用户详情
    getMemberInfo() {
      let that = this;
      let data = { memberId: that.userInfo.Id }
      that.$get(this.$interface.GetMemberInfo, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data;
          that.memberInfo = data;
          console.log('memberInfo', data)
          //setInfo('HeadPortrait',data.HeadPortrait)
          setInfo('LocationIcon', data.LocationIcon)
          setInfo('LocationName', data.LocationName)
          setInfo('IsSeller', data.IsSeller)
          that.userInfo = getInfo();
          if(data.IsSeller==true){
            window.location.href=process.env.VUE_APP_SELL_URL
          }
        }
      })
    },
    ShippingFee() {
      // let url='/login'
      // url=process.env.VUE_APP_INTLPAY+'/user/SetInfo?id='+this.email //+this.userInfo.MappingUserId
      // window.location.href=url;
      //   console.log(url)
      let url='/login'
        this.disabled=true;
      if(this.userInfo!=null){
        url=process.env.VUE_APP_INTLPAY+'/user/SetInfo?id='+this.userInfo.MappingUserId //+this.userInfo.MappingUserId
        window.location.href=url;
      }else{
        this.$router.push({
          path: url
        })
      }
    },
  },
}

</script>
<style scoped>
.oversea {
  background-color: rgba(240, 243, 255,1);
  width: 100%;
  position: relative;
}
.oversea:before {
  content: "";
  background:url(../../../static/images/activty/becomeseller/bg.png) center;
  background-size: auto 80%;
  position: absolute;
  width: 100%;
  height: 100%;
/*  transform: rotate(-45deg);*/
}

.detailbg{
  width:646px;
  position: relative;
  margin: 0 auto;
}
.oversea img {
  width: 646px;
    display: block;
    overflow: hidden;
    margin: 52px auto 80px;
}

.oversea>div {
  position: relative;
}

.oversea>div>span {
  position: absolute;
  width: 100%;
  height: 80px;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/becomeseller.vue